export default class RentPricingPredictionRequest {

    constructor({latitude, longitude, area, floors, condition, balcony, parking, nrOfRooms, termType, placeId, year}) {
        this.area=area;
        this.floors=floors;
        this.year=year;
        this.condition=condition;
        balcony?this.balcony="yes":this.balcony="no";
        parking?this.parking="yes":this.parking="no";
        this.coordinates=latitude+","+longitude;
        this.rooms=nrOfRooms;
        this.termType=termType;
        this.placeId=placeId;
    }
}
  


// WEBPACK FOOTER //
// ./src/pricing/vo/RentPricingPredictionRequest.js